const company = {
  statusCode: 200,
  body: '{"accessGranted": true, "defaultCompany": "afea47c6-d3b3-4482-94a1-4977f6b2567f", "companies": [{"name": "test", "companyId": "fe70ba3b-4d60-487c-b8fb-e9e830292b67"}, {"name": "company ABC", "companyId": "fe70ba3b-4d60-487c-b8fb-e9e830292b66"}, {"name": "company3", "companyId": "369ff5dd-7374-4f36-a509-9b6f0b5f831b"}, {"name": "Coker Company", "companyId": "afea47c6-d3b3-4482-94a1-4977f6b2567f"}], "roles": [{"application": "sketch", "role": "user"}]}',
};

export default company;
